<template>
  <div :class="{ label: true, [type]: true }">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    type: {
      type: String,
      default: '',
      validator: (value) => ['success', 'alert', 'error'].includes(value.toLowerCase()),
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  display: inline-block;
  font-size: var(--track-font-size-xxs);
  font-weight: var(--track-font-weight-semibold);
  background-color: var(--track-color-bluegray-20);
  color: var(--track-color-bluegray-60);
  padding: var(--track-spacing-sm) var(--track-spacing-md);
  border-radius: var(--track-border-radius-sm);
}

.success {
  color: var(--track-color-positive-medium);
  background: var(--track-color-positive-lightest);
}

.alert {
  color: var(--track-color-neutral-medium);
  background: var(--track-color-neutral-lightest);
}

.error {
  color: var(--track-color-negative-medium);
  background: var(--track-color-negative-lightest);
}
</style>
